<template>
	<div>
		<navTitle><div class="pageTitle">{{ title }}</div></navTitle>
		<div class="pages">
			<div class="title">{{ title }}</div>
			<div class="content" v-html="content"></div>
		</div>
		
	</div>
</template>

<script>
	/* eslint-disable */
	export default {
		watch: {
		},
		data() {
			return{
				titleArr: {
					privacy: '关于隐私',
					system: '关于该系统'
				},
				title: '关于隐私',
				titleTag: 'privacy',
				content: ''
			}
		},
		created() {
			this.titleTag = this.$route.query.name
			if (this.$route.query.name) {
				this.title = this.titleArr[this.$route.query.name];
				this.getInfo()
			}
			else {
				this.title = 'error'
				this.$toast.fail('错误')
			}
		},
		mounted() {
			this.$wx.ready(() => {
				this.$wx.updateAppMessageShareData({
					title: '福建省民族管弦乐学会',
					desc: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
				this.$wx.updateTimelineShareData({
					title: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
			});
		},
		methods: {
			getInfo() {
				this.$get('api/common/getConfig').then(res => {
					if (this.$route.query.name == 'privacy') {
						this.content = res.data.system_privacy
					} else if (this.$route.query.name == 'system') {
						this.content = res.data.system_about_us
					}
				})
			}
		}
	}
</script>
<style scoped>
	.content >>> img {
		max-width: 100%;
		height: auto;
	}
</style>
<style scoped lang="stylus">
.pages
	background-color #FFFFFF
	padding 24px 30px
	.title
		width 100%
		text-align center
		font-size: 32px;
		font-weight: bold;
		color: #000000;
</style>
